if (!customElements.get('spec-table-component')) {
  class SpecTableComponent extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-spec-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-spec-panel]'));

      if (this.tabs.length === 0) return;

      this.tabClickHandlers = this.tabs.map((tab, index) => {
        const handler = () => this.setActive(index);
        tab.addEventListener('click', handler);
        return handler;
      });
    }

    disconnectedCallback() {
      if (!this.tabs) return;
      this.tabs.forEach((tab, i) => {
        if (this.tabClickHandlers) tab.removeEventListener('click', this.tabClickHandlers[i]);
      });
    }

    setActive(index) {
      this.tabs.forEach((tab, i) => {
        tab.classList.toggle('is-active', i === index);
        tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
        tab.setAttribute('tabindex', i === index ? '0' : '-1');
      });
      this.panels.forEach((panel, i) => {
        panel.classList.toggle('is-active', i === index);
      });
    }
  }

  customElements.define('spec-table-component', SpecTableComponent);
}
